export default __webpack_public_path__ + "static/media/bussiness_tutorial_n.fcef2f17.svg";